import { Loader2 } from 'lucide-react';
import { Button } from '@components/ui/button';

interface SubmitBarProps {
  loading: boolean;
}

export default function SubmitBar({ loading }: SubmitBarProps) {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-background/95 backdrop-blur border-t border-border z-40">
      <div className="max-w-[1024px] mx-auto px-6 py-4 flex items-center justify-center">
        <Button 
          type="submit" 
          form="enquiry-form"
          disabled={loading}
          className="min-w-[200px] text-sm font-bold uppercase tracking-[0.05em] h-10 px-8"
        >
          {loading ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Submitting...
            </>
          ) : (
            'Submit Enquiry'
          )}
        </Button>
      </div>
    </div>
  );
}
